import { useState } from 'react'
import { Chip, TextField, Spacer, Grid, GridItem, Text } from '@truepill/react-capsule'
import styled from 'styled-components'

interface ChipInputProps {
  values: string[]
  onChange: (values: string[]) => void
  placeholder: string
  label: string
  state: 'error' | 'default'
  helperText?: string
}

const ValuesMultipleSelect = ({ values, onChange, placeholder, label, state, helperText }: ChipInputProps) => {
  const [chipInput, setChipInput] = useState('')

  const handleAddChip = () => {
    const trimmed = chipInput.trim()
    if (trimmed && !values.includes(trimmed)) {
      onChange([...values, trimmed])
      setChipInput('')
    }
  }

  const handleRemoveChip = (idx: number) => {
    const newValues = values.filter((_, i) => i !== idx)
    onChange(newValues)
  }

  return (
    <div>
      {label && (
        <Text as="h3" bold>
          {label}
        </Text>
      )}
      <Spacer size="xs" />
      <Grid>
        <GridItem desktop={12} tablet={8} mobile={4}>
          <TextField
            value={chipInput}
            onChange={e => setChipInput(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                e.preventDefault()
                handleAddChip()
              }
            }}
            placeholder={placeholder || 'Add value and press Enter'}
            state={state}
            helperText={helperText}
          />
        </GridItem>
      </Grid>
      {values.length > 0 && <Spacer size="sm" />}
      <ChipsContainer>
        {values.map((val, idx) => (
          <Chip key={val + idx} onDismiss={() => handleRemoveChip(idx)}>
            {val}
          </Chip>
        ))}
      </ChipsContainer>
      <Spacer size="sm" />
    </div>
  )
}

const ChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

export default ValuesMultipleSelect
